import { getSortedRowModel } from "@tanstack/react-table";

import { SystemOverviewMetricType } from "$/__generated__/graphql";
import { LoadingSpinner } from "components/loaders";
import { SummariesToggle } from "components/toggles";

import { DataTableVirtualized } from "./DataTableVirtualized";
import type { OverviewDataTablesProps } from "./types";

export const OverviewDataTables = <TData,>({
  loading,
  showFoot,
  data,
  columns,
  setShowFoot,
  onFetchMore,
  isFetchingMore,
  selectionValue,
  systemValue,
  onSelectionChange,
  onSystemChange,
}: OverviewDataTablesProps<TData>) => {
  const extraControls = showFoot ? (
    <SummariesToggle<SystemOverviewMetricType>
      metricEnum={SystemOverviewMetricType}
      selectionMetric={selectionValue}
      systemMetric={systemValue}
      onSelectionMetricChange={onSelectionChange}
      onSystemMetricChange={onSystemChange}
    />
  ) : undefined;

  return (
    <LoadingSpinner
      loading={loading && !isFetchingMore}
      className="h-full rounded shadow-column"
    >
      <DataTableVirtualized<TData>
        onFetchMore={onFetchMore}
        tableOptions={{
          columns,
          data,
          getSortedRowModel: getSortedRowModel<TData>(),
        }}
        showFoot={showFoot}
        setShowFoot={setShowFoot}
        extraControls={extraControls}
      />
    </LoadingSpinner>
  );
};

export default OverviewDataTables;
